module.exports = __webpack_public_path__ + "img/bg_staking.b766617e.png";